import React from 'react'

function highlightPart(text, query) {
  if (!query) return text

  const regexp = new RegExp(query, 'ig')
  const matches = text.match(regexp)

  if (!matches) return text

  const splitted = text.split(regexp)

  return splitted.map((part, i) => {
    if (i < splitted.length - 1) {
      const matchedText = matches.shift()
      return (
        <React.Fragment key={i}>
          {part}
          <span style={{ background: '#1CCF9E', opacity: 0.8 }}>{matchedText}</span>
        </React.Fragment>
      )
    }

    return part
  })
}

export const Highlighting = ({ data, match, className }) => {
  const { message, event_keyword, event_link } = data

  const basicString = event_keyword ? message.replace(event_keyword, '').trim() : message

  const action = event_keyword ? event_keyword.charAt(0).toUpperCase() + event_keyword.slice(1) : ''

  const highlightedBasic = highlightPart(basicString, match)
  const highlightedLinkText = highlightPart(action, match)

  const linkElement = event_link ? <a href={event_link}>{highlightedLinkText}</a> : null

  return (
    <span className={className}>
      {highlightedBasic}
      {linkElement && ' '}
      {linkElement && <span style={{ fontWeight: '600' }}>{linkElement}</span>}
    </span>
  )
}
